import React from 'react'
import moment from 'moment'

// material ui
import Hidden from '@mui/material/Hidden'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Link from '@mui/material/Link'

// atomic components
import Typography from '@mui/material/Typography'

const Sweepstakes = props => {
  const endDate = moment().endOf('month')
  const headline = 'Win an Apple Watch or Amazon Gift Certificate'

  return (
    <Card elevation={1}>
      <CardContent>
        <Hidden smUp>
          <Typography variant='h3' align='center'>
            {headline}
          </Typography>
        </Hidden>
        <Grid container justifyContent='center' alignItems='center'>
          <Grid item xs={4} sm={3}>
            <Box
              component='img'
              src='https://skc-mancala.s3.us-east-1.amazonaws.com/production/assets/apple_watch_series_11.png'
              sx={{
                m: 2,
                display: 'block',
                width: '100%',
                mx: 'auto',
                maxWidth: '140px'
              }}
            />
          </Grid>
          <Grid item xs={8} sm={9}>
            <Box p={2}>
              <Hidden smDown>
                <Typography mb={2} variant='h3' align='center'>
                  {headline}
                </Typography>
              </Hidden>

              <Typography fontWeight='bold'>
                Pay with your bank account and be automatically entered to win
                an Apple Watch (your choice of size and color) or an Amazon gift
                certificate of the same value ($399).
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Typography mt={2} variant='body2'>
          Sweepstakes ends {endDate.format('M/D/YYYY')}. Must be 18 years old to
          participate. No purchase necessary. You can also enter by mail. See{' '}
          <Link
            underline='always'
            href='/images/sweepstakes.pdf'
            target='_blank'
          >
            official sweepstakes rules
          </Link>{' '}
          for details.
        </Typography>
      </CardContent>
    </Card>
  )
}

export default Sweepstakes
